<template>
  <div class="pd-20 pd-lg-25 pd-xl-30">
    <h3 class="tx-16 tx-sm-20 tx-md-24 mg-b-15 mg-md-b-20">{{ task.task }}</h3>
    <p class="tx-14 tx-md-16 tx-color-02" v-html="task.taskDesc"></p>
  </div>
</template>

<script>
export default {
  props: {
    task: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style></style>
